import React, { useEffect, useState, useMemo } from "react";
import mailIcon from "../../assets/design-revamp/franchise-mail.svg";
import { useTranslation } from "react-i18next";
import "./index.css";
import { sendEmail } from "../../apis/Email/EmailApiInvestment";
import { useParams } from "react-router-dom";
import { getProfile } from "../../apis/User";
import CloseIcon from "@mui/icons-material/Close";

export function SendMailInvestee({ setOpen }) {
  const { t } = useTranslation();
  const [receiverName, setReceiverName] = useState("");
  const [body, setBody] = useState("");
  const [sender, setSender] = useState("");
  const [receiver, setReceiver] = useState("");
  const [subject, setSubject] = useState("");

  const { businessId } = useParams();
  useMemo(() => {
    setSubject(t("INVESTMENT_SUBJECT"));
  }, [t]);

  useEffect(() => {
    const generatedMessage = `${t("DEAR")} ${receiverName},\n\n${t(
      "SCOPE_MAIL_2_INVESTEE"
    )}\n${sender}`;
    setBody(generatedMessage);
  }, [receiverName, sender, t]);

  const handleSend = () => {
    sendEmail({
      sender: sender,
      receiver: receiver,
      subject: subject,
      body: body,
    });

    setOpen(false);
  };

  useEffect(() => {
    getProfile({
      setName: setSender,
    });
  }, [businessId]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        flexWrap: "wrap",
        padding: "20px 30px",
        position: "relative",
      }}
      className="email-investee-bg"
    >
      <CloseIcon
        onClick={() => setOpen(false)}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "50",
          paddingRight: "10px",
          width: "40px",
          height: "40px",
        }}
      />
      <div className="emailMessageIcon">
        <img src={mailIcon} alt="Email Icon" width={60} height={60} />
      </div>
      <p
        style={{ maxWidth: "680px", marginTop: "20px" }}
        className="text-email bold"
      >
        {t("SCOPE_MAIL_1_INVESTEE")}
      </p>
      <div
        className="d-flex flex-column"
        style={{ margin: "0 auto", maxWidth: "720px" }}
      >
        <div
          style={{ display: "flex", marginBottom: "8px", alignItems: "center" }}
        >
          <h6 style={{ marginRight: "5px" }} className="text-email">
            {t("DEAR")}
          </h6>
          <input
            type="text"
            value={receiverName}
            onChange={(e) => setReceiverName(e.target.value)}
            placeholder={t("INVESTEE_NAME")}
            className="email-input-bg"
          />
          <h6>,</h6>
        </div>
        <h6
          style={{ whiteSpace: "pre-wrap", marginBottom: "5px" }}
          className="text-email"
        >
          {t("SCOPE_MAIL_2_INVESTEE")}
        </h6>
        <div>
          <input
            type="text"
            value={sender}
            onChange={(e) => setSender(e.target.value)}
            placeholder={t("YOUR_NAME")}
            className="email-input-bg"
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          margin: "30px 0",
        }}
      >
        <label
          style={{
            color: "#2C5B47",
            fontSize: "12px",
            fontWeight: "bold",
            marginRight: "5px",
          }}
        >
          {t("SEND_MAIL_SCOPE")}
        </label>
        <input
          type="text"
          value={receiver}
          onChange={(e) => setReceiver(e.target.value)}
          className="email-input-bg"
          placeholder="name@email.com"
        />
        <img
          src={mailIcon}
          alt="Email Icon"
          width={22}
          height={22}
          onClick={handleSend}
          style={{ marginLeft: "5px", cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
